var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVipps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 42C32.598 42 42 32.598 42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42Z",
    fill: "#FF5B24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5059 17.1805C27.1115 17.1805 28.4876 15.9615 28.4876 14.2094H28.4879C28.4879 12.4569 27.1115 11.2383 25.5059 11.2383C23.9006 11.2383 22.5248 12.4569 22.5248 14.2094C22.5248 15.9615 23.9006 17.1805 25.5059 17.1805ZM29.4048 21.981C27.4167 24.5709 25.3144 26.3615 21.6063 26.3615H21.6068C17.8237 26.3615 14.8797 24.0757 12.5864 20.7237C11.6687 19.3521 10.2544 19.0475 9.22224 19.7713C8.26677 20.4571 8.03799 21.9047 8.91661 23.162C12.089 28 16.4846 30.8185 21.6063 30.8185C26.3085 30.8185 29.9782 28.5332 32.8446 24.7236C33.9145 23.3143 33.8764 21.8668 32.8446 21.0666C31.8886 20.304 30.4744 20.5719 29.4048 21.981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipps);
export default __webpack_public_path__ + "static/media/Vipps.db14c4c8f76fca57fcb73b5e3e1af461.svg";
export { ForwardRef as ReactComponent };